var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, QueryList } from '@angular/core';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { ExcelService } from '@app/excel.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
var ReportComponent = /** @class */ (function () {
    function ReportComponent(util, apiService, excel) {
        this.util = util;
        this.apiService = apiService;
        this.excel = excel;
        this.agentList = [];
        this.role = {};
        this.caseSubTypeList = [];
        this.totalHigh = 0;
        this.totalMedium = 0;
        this.totalLow = 0;
        this.criCaseType = "";
        this.criCaseSubType = "";
        this.criChannel = "";
        this.criStatus = "";
        this.criSLA = "";
        this.criPriority = "";
        this.criCreate = "";
        this.criModify = "";
        this.criCallcenterteam = "";
        this.reportList = [];
        this.dtReport = null;
    }
    ReportComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs;
            return __generator(this, function (_a) {
                this.util.ShowWaiting(true);
                thisTs = this;
                this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"));
                this.role = JSON.parse(this.cookieData.role);
                this.myTeams = JSON.parse(this.cookieData.teams);
                this.callApi();
                //await this.initDropdown()
                $(".select2").select2();
                $(thisTs.criFromCreateDate.nativeElement).on('changeDate', function (ev) {
                    thisTs.createDateFromObj = ev.date;
                    $(thisTs.criToCreateDate.nativeElement).datepicker('setStartDate', ev.date);
                    if (thisTs.createDateToObj) {
                        $(thisTs.criToCreateDate.nativeElement).datepicker('setDate', thisTs.createDateToObj);
                    }
                });
                $(thisTs.criToCreateDate.nativeElement).on('changeDate', function (ev) {
                    thisTs.createDateToObj = ev.date;
                    $(thisTs.criFromCreateDate.nativeElement).datepicker('setEndDate', ev.date);
                    if (thisTs.createDateFromObj) {
                        $(thisTs.criFromCreateDate.nativeElement).datepicker('setDate', thisTs.createDateFromObj);
                    }
                });
                $(thisTs.criFromModifyDate.nativeElement).on('changeDate', function (ev) {
                    thisTs.updateDateFromObj = ev.date;
                    $(thisTs.criToModifyDate.nativeElement).datepicker('setStartDate', ev.date);
                    if (thisTs.updtaeDateToObj) {
                        $(thisTs.criToModifyDate.nativeElement).datepicker('setDate', thisTs.updtaeDateToObj);
                    }
                });
                $(thisTs.criToModifyDate.nativeElement).on('changeDate', function (ev) {
                    thisTs.updtaeDateToObj = ev.date;
                    $(thisTs.criFromModifyDate.nativeElement).datepicker('setEndDate', ev.date);
                    if (thisTs.updateDateFromObj) {
                        $(thisTs.criFromModifyDate.nativeElement).datepicker('setDate', thisTs.updateDateFromObj);
                    }
                });
                this.util.ShowWaiting(false);
                return [2 /*return*/];
            });
        });
    };
    ReportComponent.prototype.callApi = function () {
        return forkJoin([
            this.initDropdown()
        ]);
    };
    ReportComponent.prototype.initDropdown = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var para_1, _a, _b, _c, _d, _e, _f, teams;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (!(this.myTeams != null && this.myTeams.length > 0)) return [3 /*break*/, 2];
                        para_1 = "";
                        this.myTeams.forEach(function (t) {
                            if (para_1 != "") {
                                para_1 += "&";
                            }
                            para_1 += "callcenterteam=" + t.dpa_callcenterteamid;
                        });
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("crmservice", "callcenterProfile", para_1)
                            // let agents: any = tmp.filter((t: any) => { return t.dpa_teamidlist != null && t.dpa_teamidlist.length > 0})
                            // this.myTeams.forEach((t: any) => {
                            //   agents.forEach((a: any) => {
                            //     if (this.agentList.indexOf(a) == -1) {
                            //       let match: any = a.dpa_teamidlist.filter((at: any) => {
                            //         return at.dpa_callcenterteamid == t.dpa_callcenterteamid
                            //       })
                            //       if (match != null && match.length > 0) {
                            //         this.agentList.push(a)
                            //       }
                            //     }
                            //   })
                            // });
                        ];
                    case 1:
                        _a.agentList = _g.sent();
                        _g.label = 2;
                    case 2:
                        _b = this;
                        return [4 /*yield*/, this.apiService.get("master", "caseChannel")];
                    case 3:
                        _b.caseChannelList = _g.sent();
                        _c = this;
                        return [4 /*yield*/, this.apiService.get("master", "caseStatus")];
                    case 4:
                        _c.caseStatusList = _g.sent();
                        _d = this;
                        return [4 /*yield*/, this.apiService.get("master", "caseSeverity")];
                    case 5:
                        _d.caseSeverityList = _g.sent();
                        _e = this;
                        return [4 /*yield*/, this.apiService.get("master", "caseType")];
                    case 6:
                        _e.caseTypeList = _g.sent();
                        _f = this;
                        return [4 /*yield*/, this.apiService.get("master", "caseSubType")];
                    case 7:
                        _f.subTypeTmpList = _g.sent();
                        return [4 /*yield*/, this.apiService.get("master", "callcenterTeam")];
                    case 8:
                        teams = _g.sent();
                        this.teamList = teams.filter(function (t) {
                            return _this.myTeams.map(function (mt) { return mt.dpa_callcenterteamid; }).indexOf(t.dpa_callcenterteamid) > -1;
                        });
                        this.util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    ReportComponent.prototype.onCaseTypeChange = function () {
        var _this = this;
        if (this.criCaseType != null && this.criCaseType.length > 0) {
            this.caseSubTypeList = this.subTypeTmpList.filter(function (subType) { return subType.dpa_casetypeid === _this.criCaseType; });
        }
    };
    ReportComponent.prototype.resetCriteriaForm = function () {
        this.criCaseType = "";
        this.criCaseSubType = "";
        this.criChannel = "";
        this.criStatus = "";
        this.criSLA = "";
        this.criPriority = "";
        this.criCreate = "";
        this.criModify = "";
        $('[data-provide="datepicker"]').val("").datepicker("update");
    };
    ReportComponent.prototype.search = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, fromCreateDt, toCreateDt, fromModifyDt, toModifyDt, filteredList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        para = "";
                        fromCreateDt = $(this.criFromCreateDate.nativeElement).val();
                        toCreateDt = $(this.criToCreateDate.nativeElement).val();
                        fromModifyDt = $(this.criFromModifyDate.nativeElement).val();
                        toModifyDt = $(this.criToModifyDate.nativeElement).val();
                        if (this.criChannel != null && this.criChannel != "") {
                            para += (para.length > 0 ? "&" : "") + "case_channel=" + this.criChannel;
                        }
                        if (this.criCaseType != null && this.criCaseType != "") {
                            para += (para.length > 0 ? "&" : "") + "case_type=" + this.criCaseType;
                        }
                        if (this.criCaseSubType != null && this.criCaseSubType != "") {
                            para += (para.length > 0 ? "&" : "") + "case_subtype=" + this.criCaseSubType;
                        }
                        if (this.criStatus != null && this.criStatus != "") {
                            para += (para.length > 0 ? "&" : "") + "case_status=" + this.criStatus;
                        }
                        if (this.criPriority != null && this.criPriority != "") {
                            para += (para.length > 0 ? "&" : "") + "case_priority=" + this.criPriority;
                        }
                        if (this.criSLA != null && this.criSLA != "") {
                            para += (para.length > 0 ? "&" : "") + "case_sla=" + this.criSLA;
                        }
                        if (fromCreateDt != null && fromCreateDt != "") {
                            para += (para.length > 0 ? "&" : "") + "case_date_from=" + moment($(this.criFromCreateDate.nativeElement).data('datepicker').date).format("YYYY-MM-DD");
                        }
                        if (toCreateDt != null && toCreateDt != "") {
                            para += (para.length > 0 ? "&" : "") + "case_date_to=" + moment($(this.criToCreateDate.nativeElement).data('datepicker').date).format("YYYY-MM-DD");
                        }
                        if (fromModifyDt != null && fromModifyDt != "") {
                            para += (para.length > 0 ? "&" : "") + "case_modified_from=" + moment($(this.criFromModifyDate.nativeElement).data('datepicker').date).format("YYYY-MM-DD");
                        }
                        if (toModifyDt != null && toModifyDt != "") {
                            para += (para.length > 0 ? "&" : "") + "case_modified_to=" + moment($(this.criToModifyDate.nativeElement).data('datepicker').date).format("YYYY-MM-DD");
                        }
                        if (this.criCreate != null && this.criCreate != "") {
                            para += (para.length > 0 ? "&" : "") + "createby=" + this.criCreate;
                        }
                        if (this.criModify != null && this.criModify != "") {
                            para += (para.length > 0 ? "&" : "") + "modifiedby=" + this.criModify;
                        }
                        if (this.criCallcenterteam != null && this.criCallcenterteam != "") {
                            para += (para.length > 0 ? "&" : "") + "callcenterteam=" + this.criCallcenterteam;
                        }
                        else {
                            if (this.myTeams != null && this.myTeams.length > 0) {
                                this.myTeams.forEach(function (t) {
                                    para += (para.length > 0 ? "&" : "") + "callcenterteam=" + t.dpa_callcenterteamid;
                                });
                            }
                        }
                        if (!(para.length > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.apiService.get("crmservice", "summaryCaseReport", para)];
                    case 1:
                        filteredList = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.apiService.get("crmservice", "summaryCaseReport")];
                    case 3:
                        filteredList = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, filteredList];
                }
            });
        });
    };
    ReportComponent.prototype.view = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        $('#tbReport').DataTable().clear().destroy();
                        _a = this;
                        return [4 /*yield*/, this.search()];
                    case 1:
                        _a.reportList = _b.sent();
                        this.totalHigh = this.totalMedium = this.totalLow = 0;
                        this.reportList.forEach(function (r) {
                            if (r.dpa_caseseverityidname != null && r.dpa_caseseverityidname.toLocaleLowerCase() == "high") {
                                _this.totalHigh++;
                            }
                            else if (r.dpa_caseseverityidname != null && r.dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
                                _this.totalMedium++;
                            }
                            else if (r.dpa_caseseverityidname != null && r.dpa_caseseverityidname.toLocaleLowerCase() == "low") {
                                _this.totalLow++;
                            }
                        });
                        this.util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    ReportComponent.prototype.exportExcel = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tmpResultList, resultList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        return [4 /*yield*/, this.search()];
                    case 1:
                        tmpResultList = _a.sent();
                        resultList = [];
                        tmpResultList.forEach(function (r) {
                            var rowData = {
                                //Priority: r.dpa_caseseverityidname,
                                SLA: r.dpa_issla ? 'Over' : '',
                                CaseID: r.ticketnumber,
                                ชื่อ: r.firstname,
                                นามสกุล: r.lastname,
                                หมายเลขโทรศัพท์: r.telephone1,
                                ช่องทางการติดต่อ: r.dpa_casechannelidname,
                                ประเภทรายงานการติดต่อ: r.dpa_casetypeidname,
                                หัวข้อการติดต่อ: r.dpa_casesubtypeidname,
                                รายละเอียด: r.description,
                                คำตอบ: r.dpa_resolution,
                                PDPA: r.dpa_pdpa_flag,
                                สถานะ: r.dpa_casestatusidname,
                                วันที่สร้าง: r.createdon == null ? "" : moment(r.createdon.replace("Z", "")).format('DD/MM/YYYY HH:mm:ss'),
                                ผู้ที่สร้าง: r.dpa_createdby,
                                วันที่แก้ไขล่าสุด: r.modifiedon == null ? "" : moment(r.modifiedon.replace("Z", "")).format('DD/MM/YYYY HH:mm:ss'),
                                ผู้ที่แก้ไข: r.dpa_modifiedby
                            };
                            resultList.push(rowData);
                        });
                        //this.excel.exportAsExcelFile(resultList, "report")
                        this.TableExcelReport(resultList, "report");
                        // const dataWS = XLSX.utils.json_to_sheet(content)
                        //   const wb = XLSX.utils.book_new()
                        //   XLSX.utils.book_append_sheet(wb, dataWS)
                        //   XLSX.writeFile(wb,'export.xlsx')
                        this.util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    ReportComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.tbR.changes.subscribe(function (t) {
            _this.initTableReport();
        });
    };
    ReportComponent.prototype.ngForRendred = function () {
        console.log('NgFor is Rendered');
        if (this.dtReport == null) {
            this.initTableReport();
        }
    };
    ReportComponent.prototype.initTableReport = function () {
        this.dtReport = $("#tbReport").dataTable({
            retrieve: true,
            "searching": false,
            "language": {
                "paginate": {
                    "previous": "<",
                    "next": ">"
                }
            }
        });
    };
    ReportComponent.prototype.TableExcelReport = function (form_data, filename) {
        if (form_data != null) {
            if (form_data.length > 0) {
                var tab_text = '<table border="1" ><thead><tr style="background-color: #BEE762">';
                for (var key in form_data[0]) {
                    tab_text += "<th>" + key + "</th>";
                }
                tab_text += "</tr></thead><tbody>";
                for (var i = 0; i < form_data.length; i++) {
                    tab_text += "<tr>";
                    for (var key in form_data[i]) {
                        if (form_data[i][key] == null) {
                            tab_text += "<td></td>";
                        }
                        else {
                            tab_text += "<td>" + form_data[i][key] + "</td>";
                        }
                    }
                    tab_text += "</tr>";
                }
                tab_text += "</tbody></table>";
                var uri = 'data:application/vnd.ms-excel;base64,', template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>', base64 = function (s) {
                    return window.btoa(unescape(encodeURIComponent(s)));
                }, format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }); };
                var ctx = { worksheet: "a" || 'Worksheet', table: tab_text };
                window.location.href = uri + base64(format(template, ctx));
            }
            else {
                this.util.ErrorDialog('ไม่พบข้อมูล');
            }
        }
        else {
            this.util.ErrorDialog('ไม่พบข้อมูล');
        }
    };
    return ReportComponent;
}());
export { ReportComponent };



// WEBPACK FOOTER //
// ./src/app/report/report.component.ts.pre-build-optimizer.js